var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('alert',{attrs:{"type":"error"}},[_vm._v(" We are currently experiencing technical difficulties. Please try again later. ")])
}
var staticRenderFns = []

export { render, staticRenderFns }